<app-loading />
@if (orderCheckHistory.customerName) {
<div class="w-100 p-y-10 p-x-20 ai-center gap-10 bg-secondary text-center text-title-category">
    Está atendendo a {{orderCheckHistory.customerName}}
</div>
}
<header class="pos-relative">
    <div class="w-100 h-px-70 bg-primary">
        @if ((orderCheck.OrderCheckCode ?? 0) > 0) {
        <div class="d-flex ai-center p-x-20 p-y-10 gap-10">
            <div class="f-s-16 text-text-color f-w-100"> {{orderCheck.IsGroupCheck ? 'Mesa' : 'Comanda'}} </div>
            <div class="f-s-40 text-text-color f-w-600">{{(orderCheck.OrderCheckCode ?? 0) > 0 ?
                orderCheck.OrderCheckCode :
                ''}}
            </div>
        </div>
        }
    </div>
    <img [src]="parameterization.CompanyLogoUrl ? parameterization.CompanyLogoUrl : '/assets/images/imageDefault.png'"
        alt="Logo" class="pos-absolute right-5 translate-center w-px-80 h-px-80 rounded-8">
</header>
<div class="w-100 max-width-900">
    <main class="pageWraper p-x-20 p-y-10">
        <router-outlet />
    </main>

    <div class="pos-fixed w-100 bottom-10 max-width-900">
        <app-footer />
    </div>
</div>